/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Issue_Sign_Missing_PlInputs */

const en_statement_taxonomy_issue_sign_missing_pl = /** @type {(inputs: Statement_Taxonomy_Issue_Sign_Missing_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profit & loss needs both debit and credit rows`)
};

const nl_statement_taxonomy_issue_sign_missing_pl = /** @type {(inputs: Statement_Taxonomy_Issue_Sign_Missing_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De W&V-rekening heeft zowel debet- als creditregels nodig`)
};

/**
* | output |
* | --- |
* | "Profit & loss needs both debit and credit rows" |
*
* @param {Statement_Taxonomy_Issue_Sign_Missing_PlInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_issue_sign_missing_pl = /** @type {((inputs?: Statement_Taxonomy_Issue_Sign_Missing_PlInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Issue_Sign_Missing_PlInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_issue_sign_missing_pl(inputs)
	return en_statement_taxonomy_issue_sign_missing_pl(inputs)
});